<template>
    <div
        :class="[
            'z-textarea',
            {
                'is-focused': isFocused,
                'is-errored': isValid === false,
                'is-valid': isValid,
                'is-filled': textareaValue,
                'is-disabled': disabled,
                'is-resizable': resize,
                'is-required': required
            }
        ]">
        <label class="z-textarea__label">
            <textarea
                class="z-textarea__textarea"
                name="name"
                v-bind="$attrs"
                @blur="onBlur"
                @focus="onFocus"
                @input="onInput($event)"
                @change="onChange($event)"
                v-model="textareaValue"
                :disabled="disabled"
                cols="30"
                rows="4"
            ></textarea>
            <span
                v-show="placeholder"
                v-html="placeholder"
                class="z-textarea__placeholder"
            ></span>
        </label>
        <span
            :class="[
                'z-textarea__error',
                errorClass
            ]"
            v-html="error"
            v-if="error && !isValid"
        ></span>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import {localize} from '@/utils/i18n'

const props = defineProps({
    placeholder: String,
    modelValue: [Number, String],
    name: {
        type: String,
        required: true
    },
    required: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    resize: {
        type: Boolean,
        default: false
    },
    errorClass: {
        type: String,
        default: ''
    },
    validateOnBlur: {
        type: Boolean,
        default: true
    }
})

const localValue =  ref(null)
const isFocused =  ref(false)
const isValid =  ref(null)
const error =  ref('')

const emit = defineEmits([
    'update:modelValue',
    'change',
    'input'
])

const text = {
    error: {
        ru: 'Поле обязательно для заполнения',
        en: 'Required field'
    }
}

const textareaValue = computed({
    get () {
        if (props.modelValue !== undefined) return props.modelValue
        return localValue.value
    },
    set (value) {
        emit('input', value)
        emit('update:modelValue', value)
        localValue.value = value
    }
})

const onBlur = () => {
    isFocused.value = false
    if (props.validateOnBlur) validate()
}

const onFocus = () => {
    isFocused.value = true
}

const onInput = (e) => {
    emit('input', e.target.value)
    emit('update:modelValue', e.target.value)
    if (isValid.value !== null) nextTick(validate)
}

const onChange = (e) => {
    emit('change', e.target.value)
    emit('update:modelValue', e.target.value)
}

const validate = () => {
    if (props.required && !textareaValue.value) {
        isValid.value = false
        error.value = localize(text.error)
        return
    }

    textareaValue.value ? isValid.value = true : isValid.value = null
    error.value = ''
}

defineExpose({
    validate,
    error
})
</script>

<style lang="scss" src="./index.scss">
</style>
